import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { CatalogPageRoutingModule } from './catalog-routing.module';

import { CatalogPage } from './catalog.page';
import { SharedModule } from 'src/app/shared/shared.module';
import { SearchSharedModule } from '../shared/search-shared.module';
import { ProductCategoryComponent } from './components/product-category/product-category.component';
import { SearchCatalogSkeletonComponent } from './components/search-catalog-skeleton/search-catalog-skeleton.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    SharedModule,
    SearchSharedModule,
    CatalogPageRoutingModule,
  ],
  declarations: [
    CatalogPage,
    ProductCategoryComponent,
    SearchCatalogSkeletonComponent,
  ],
})
export class CatalogPageModule {}
